/**
 * MixViewWrapper Component
 * Wrapper for the MixView (Pro Tools style full mixer view)
 */

import React from 'react';
import { MixView } from '../mixer';

export const MixViewWrapper = ({
  viewMode,
  tracks,
  masterVolume,
  selectedTrackId,
  // Track handlers
  handleMixerVolumeChange,
  handleMixerPanChange,
  handleMixerMuteToggle,
  handleMixerSoloToggle,
  setSelectedTrack,
  handleMixerNameChange,
  setMasterVolume,
  // Effects handlers
  handleAddEffect,
  handleRemoveEffect,
  handleToggleEffect,
  handleReorderEffects,
  handleEffectParamChange,
  // Drag & drop
  draggedTrackId,
  dragOverTrackId,
  dropPosition,
  handleDragStart,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleDragEnd,
}) => {
  if (viewMode !== 'mix') return null;
  
  return (
    <MixView
      tracks={tracks}
      masterVolume={masterVolume}
      selectedTrackId={selectedTrackId}
      onTrackVolumeChange={handleMixerVolumeChange}
      onTrackPanChange={handleMixerPanChange}
      onTrackMuteToggle={handleMixerMuteToggle}
      onTrackSoloToggle={handleMixerSoloToggle}
      onTrackSelect={setSelectedTrack}
      onTrackNameChange={handleMixerNameChange}
      onMasterVolumeChange={setMasterVolume}
      onAddEffect={handleAddEffect}
      onRemoveEffect={handleRemoveEffect}
      onToggleEffect={handleToggleEffect}
      onReorderEffects={handleReorderEffects}
      onEffectParamChange={handleEffectParamChange}
      // Drag & drop props for track reordering
      draggedTrackId={draggedTrackId}
      dragOverTrackId={dragOverTrackId}
      dropPosition={dropPosition}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onDragEnd={handleDragEnd}
    />
  );
};

export default MixViewWrapper;
